import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import StepBar from "components/stepBar";
import { GeneralInfoStep } from "./generalInfo";
import { BusinessStep } from "./business";
import { CreditHistoryStep } from "./creditHistory";
import { AddressStep } from "./address";
import { ServiceStep } from "./service";
import { OwnerStep } from "./owner";
import { DocumentsStep } from "./documents";
import { RequiredMarkContext } from "components/contexts/requiredMarkContext";

import styles from "./stepper.module.scss";

const Stepper = () => {
	const [activeStep, setActiveStep] = useState(0);
	const { search } = useLocation();
	const token = new URLSearchParams(search)?.get("token");

	const prevStep = () => setActiveStep(i => i - 1);
	const nextStep = () => setActiveStep(i => i + 1);

	const STEPS = {
		0: <GeneralInfoStep nextStep={nextStep} token={token} />,
		1: (
			<AddressStep
				initialValues={{
					legalBusinessLocation: {
						is_legal_address_the_same: "true",
					},
				}}
				prevStep={prevStep}
				nextStep={nextStep}
				token={token}
			/>
		),
		2: (
			<BusinessStep
				prevStep={prevStep}
				nextStep={nextStep}
				token={token}
			/>
		),
		3: (
			<ServiceStep
				prevStep={prevStep}
				nextStep={nextStep}
				token={token}
			/>
		),
		4: (
			<CreditHistoryStep
				prevStep={prevStep}
				nextStep={nextStep}
				token={token}
			/>
		),
		5: (
			<OwnerStep
				prevStep={prevStep}
				nextStep={nextStep}
				token={token}
				initialValues={{}}
			/>
		),
		6: (
			<DocumentsStep
				prevStep={prevStep}
				nextStep={nextStep}
				token={token}
			/>
		),
		7: null,
	};

	return (
		<div className={styles.stepper}>
			{activeStep !== 7 && <StepBar activeStep={activeStep} />}

			<RequiredMarkContext.Provider value={true}>
				{STEPS[activeStep]}
			</RequiredMarkContext.Provider>
		</div>
	);
};

export { Stepper };
